import React from 'react';
import { compose } from 'recompose';

import connect from 'app/libs/connect';
import { userLocale, isUserAuthenticated } from 'app/features/user/selectors';
import ExternalRedirect from 'app/router/ExternalRedirect';
import { HOME_PATH } from 'app/router/constants/paths';

/* eslint-disable react/prop-types  */
const withAuthorizedRoute =
  Component =>
  ({ isAuthenticated, locale, ...restProps }) =>
    isAuthenticated ? (
      <Component {...restProps} />
    ) : (
      <ExternalRedirect to={HOME_PATH} locale={locale} />
    );
/* eslint-enable react/prop-types  */

const state = {
  isAuthenticated: isUserAuthenticated,
  locale: userLocale,
};

export { withAuthorizedRoute };

export default compose(connect(state), withAuthorizedRoute);
